import { render } from "./SignOutPage.vue?vue&type=template&id=b929c5d8&scoped=true"
import script from "./SignOutPage.vue?vue&type=script&lang=js"
export * from "./SignOutPage.vue?vue&type=script&lang=js"

import "./SignOutPage.vue?vue&type=style&index=0&id=b929c5d8&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b929c5d8"]])

export default __exports__